import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import { useCheckbox, useCheckboxActions, useRegisterCheckbox } from './checkbox-hooks'

export const CellContentCheckSimple = ({
  id,
  hiddenLabel,
  largeChekbox,
  keepRegisteredOnDispose,
}: {
  id: string
  hiddenLabel?: string
  largeChekbox?: boolean
  keepRegisteredOnDispose?: boolean
}) => {
  useRegisterCheckbox(id, keepRegisteredOnDispose)

  const checked = useCheckbox(id)

  const { setChecked } = useCheckboxActions()

  return (
    <PlainCheckbox
      id={id}
      label={hiddenLabel}
      value={id}
      checked={checked}
      onChange={(event) => setChecked(id, event.currentTarget.checked)}
      large={largeChekbox}
      hideLabel
    />
  )
}
